var GoogleMapsLoader = require('google-maps');

function initMap() {
    GoogleMapsLoader.KEY = 'AIzaSyAx6qgWKdufKR1BnK6vvzamjC9Av8TqMio';

    var is_internetExplorer11 = navigator.userAgent.toLowerCase().indexOf('trident') > -1,
        marker_url = (is_internetExplorer11) ? '/images/out_png/marker.png' : '/images/out_svg/marker.svg',
        mapObj = document.getElementById('contacts-map-google'),
        title = mapObj.dataset.title,
        URL = window.location.href;

    if( URL.indexOf('/ru/') + 1 ) {
        GoogleMapsLoader.LANGUAGE = 'ru';
    } else {
        GoogleMapsLoader.LANGUAGE = 'en';
    }

    var coord = {lat: 55.947468, lng: 37.419510},
        center = {lat: 55.947468, lng: 37.419510};

    var mapOptions = {
        zoom: 15,
        disableDefaultUI: true,
        zoomControl: false,
        scaleControl: true,
        center: center
    };
    var map = new google.maps.Map(mapObj, mapOptions);

    var marker = new google.maps.Marker({
        position: coord,
        map: map,
        title: title
    });
};

if ($('.js-contacts-map-google').length) {
    GoogleMapsLoader.load(function (google) {
        initMap();
    });
}



// WEBPACK FOOTER //
// ./frontend/components/contacts-map-google/contacts-map-google.js